export default class Brands {
    constructor() {
        this.brands = [
            {
                label: 'Virgin Velocity',
                group: 1,
            },
            {
                label: 'Aldar',
                group: 1,
            },
            {
                label: 'Emirates Skywards',
                group: 1,
            },
            {
                label: 'SAS EuroBonus',
                group: 1,
            },
            {
                label: 'Qatar Airways',
                group: 1,
            },
            {
                label: 'Visa',
                group: 1,
            },
            {
                label: 'FDM',
                group: 1,
            },
            {
                label: 'Jyske Bank',
                group: 2,
            },
            {
                label: 'Marriott Bonvoy',
                group: 2,
            },
            {
                label: 'Etihad Airways',
                group: 2,
            },
            {
                label: 'Air Canada Aeroplan',
                group: 2,
            },
            {
                label: 'Cathay Pacific',
                group: 2,
            },
        ];

        this.industryBrands = [
            {
                label: 'Etihad Guest',
                industry: 'Airline',
            },
            {
                label: 'SAS EuroBonus',
                industry: 'Airline',
            },
            {
                label: 'Qatar Airways',
                industry: 'Airline',
            },
            {
                label: 'Virgin Australia',
                industry: 'Airline',
            },
            {
                label: 'Emirates',
                industry: 'Airline',
            },
            {
                label: 'Air Canada',
                industry: 'Airline',
            },
            {
                label: 'Cathay Pacific',
                industry: 'Airline',
            },
            {
                label: 'Visa',
                industry: 'Financial',
            },
            {
                label: 'Jyske Bank',
                industry: 'Financial',
            },
            {
                label: 'Tymit',
                industry: 'Financial',
            },
            {
                label: 'Marriott Bonvoy',
                industry: 'Hospitality',
            },
            {
                label: 'YAS Mall',
                industry: 'Malls',
            },
            {
                label: 'WTC Mall',
                industry: 'Malls',
            },
            {
                label: 'Al Jimi Mall',
                industry: 'Malls',
            },
        ];
    }

    getAll() {
        return this.brands;
    }

    getIndustries(industry) {
        return this.industryBrands.filter(brand => brand.industry === industry);
    }
}
